import styled from 'styled-components';
import config from 'config';

import { fadeIn, zoomOutTop } from 'components/Animations';

import Card from 'components/common/Card';

const BASENAME = config.site.baseName;

const LOGO_PROPS = {
  src: `${BASENAME ? '/' : ''}${BASENAME}/img/logo.png`
};

const LOGO_TEST_PROPS = {
  src: `${BASENAME ? '/' : ''}${BASENAME}/img/searchlight.png`
};

export const LoginButtonContain = styled.div`
  padding-bottom: 8px;
  padding-top: 8px;
`;

export const LoginHeader = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  padding: 16px;
`;

export const LoginContain = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) => (props.success ? zoomOutTop : fadeIn)}
`;

export const LoginPanel = styled.div`
  width: 480px;

  margin-top: 10vh;

  ${(props) => props.theme.media.sm.max`
    margin-top: 0px;
    width: 100vw;
  `}

  ${(props) => props.theme.media.lg.min`
    width: 540px;
  `}
`;

export const LoginContent = styled.div`
  padding: 32px 16px;
  padding-top: 8px;
`;

export const LoginCard = styled(Card.Content)`
  position: relative;

  ${(props) => props.theme.media.sm.max`
    margin: 0px !important;
    box-shadow: none !important;
    border-radius: unset !important;
    height: calc(100vh) !important;
  `}
`;

export const MarginBotton = styled.div`
  margin-bottom: 8px;
`;

export const SearchLightLogo = styled.img`
  height: 80%;
`;

export const SearchLightText = styled.img`
  height: 100%;
  margin-left: 16px;
`;

SearchLightLogo.defaultProps = LOGO_PROPS;
SearchLightText.defaultProps = LOGO_TEST_PROPS;

export const Link = styled.a`
  font-family: 'Roboto';
  color: ${(props) => props.theme.brandColor};
`;

export const LinkContain = styled.div`
  padding: 16px;
  padding-bottom: 0px;
  color: ${(props) => props.theme.mediumGrey};
  text-align: right;
  font-family: 'Roboto';
`;

export const Background = styled.div`
  height: 100vh;
`;

export const HelpText = styled.p`
  font-family: 'Roboto';
  line-height: 1.5em;
  color: #333;
  margin-top: 0em;
  margin-bottom: 16px;
  font-weight: 300;
  font-size: 0.875em;
  padding: 12px;
  border-radius: 4px;
  background-color: #f9f9f9;
  box-shadow: 0px 0px 0px 1px #e6e6e6;
  display: flex;
`;

export const Header = styled.h1`
  margin: 0px;
  font-size: 1.8em;
  font-family: Roboto;
  font-weight: 400;
  color: #0a3b61;
  border-style: solid;
  border-width: 0px;
  padding-left: 16px;
`;

export const MarginRight = styled.span`
  margin-right: 8px;
`;

export const Bold = styled.b`
  font-weight: 400;
`;

export const SubHeader = styled.p`
  font-size: 0.9em;
  font-weight: 400;
  margin-bottom: 4px;
  margin-top: 0px;
  color: rgb(1, 52, 83);
  -webkit-transition: top 0.1s ease-out;
  transition: top 0.1s ease-out;
  font-family: roboto, sans-serif;
`;
